import { Locale } from 'src/types'
import { EngineTypes } from 'src/constants'

export const fuelTypeDictionary = (
  locale: Locale['addCar'],
): Record<EngineTypes, string> => {
  const { petrol, diesel, electric, hybrid, naturalGas } = locale.engineType

  return {
    [EngineTypes.Petrol]: petrol,
    [EngineTypes.Diesel]: diesel,
    [EngineTypes.Electric]: electric,
    [EngineTypes.Hybrid]: hybrid,
    [EngineTypes.NaturalGas]: naturalGas,
  }
}
